<template>
  <div>

    <div v-if="!isLoggedIn">
      <router-view />
    </div>

    <!-- MAIN APP LAYOUT -->
    <div v-else class="flex flex-col lg:flex-row h-screen overflow-hidden">

      <!-- Sidebar -->
      <SideMenu :isOpen="isMenuOpen" @close="isMenuOpen = false" />

      <!-- Main -->
      <main class="flex-1 flex flex-col min-w-0 overflow-hidden">

      <TopHeader @toggle-menu="isMenuOpen = true" />

        <!-- Page Content -->
        <div class="flex-1 overflow-y-auto">
          <router-view />
        </div>

      </main>
    </div>

  </div>
</template>


<script>
import SideMenu from './comps/SideMenu.vue'
import TopHeader from './comps/TopHeader.vue'
import { useRoute } from 'vue-router'

export default {
  components: { SideMenu, TopHeader },
  data() {
    return {
      ldata: null,
      isLoggedIn: false ,
      isMenuOpen: false
    }
  },
  mounted(){
    const route = useRoute();

    const rtype = route.query.rtype;
    if(rtype && rtype==='new_camp'){
      window.location.href = "campaign/new?rtype=zapier";
    }
    else if(rtype && rtype==='new_camp_ref'){
      window.location.href = "campaign/ref/new?rtype=zapier";
    }
    const tmp = sessionStorage.getItem("ldata")||"";
    if(tmp && tmp.length>0){
      // alert(tmp+"");
      this.isLoggedIn = true;
      this.ldata = JSON.parse(tmp);
    }
    else{
      this.isLoggedIn = false;
    }
    var segments = window.location.pathname.split("/").filter(seg => seg !== "")+"";
    if(segments.includes(",")){
      segments = segments.split(",")[0];
    }
    // alert(segments+"");
    // if (
    //   (segments && segments.localeCompare("login")==0) || 
    //   (segments && segments.localeCompare("forgot-password")==0) || 
    //   (segments && segments.localeCompare("verify-email")==0) || 
    //   (segments && segments.localeCompare("create-account")==0) || 
    //   (segments && segments.localeCompare("review")==0)
    // ) {
    //   this.isLoggedIn = false;
    // }
    // else{
    //   this.isLoggedIn = true;
    // }
  }
}
</script>
